/**
 * Per-video "like" counts.
 *
 * The single heart reaction can be tapped repeatedly; each tap increments a
 * per-video counter persisted here. Reaching `FAVORITE_THRESHOLD` likes
 * auto-saves the video to favorites.
 */
import { getJSON, setJSON } from './storage.js';

const LIKES_KEY = 'videoLikes';

export const FAVORITE_THRESHOLD = 10;

/** @returns {Record<string, number>} */
export function loadLikes() {
  const map = getJSON(LIKES_KEY, {});
  return map && typeof map === 'object' ? map : {};
}

export function saveLikes(map) {
  setJSON(LIKES_KEY, map);
}

export function getLikeCount(map, id) {
  return map[id] || 0;
}
